// extracted by mini-css-extract-plugin
export default {"price_change_container":"CoinPriceChange_price_change_container__YIlyj","market_wrapper":"CoinPriceChange_market_wrapper__zp93H","market_row":"CoinPriceChange_market_row__znY5L"};